import React from 'react';
import { FadeIn } from './FadeIn';
import { CalendarIcon, ZapIcon, BarChartIcon, TrendingUpIcon } from 'lucide-react';
export function Transformation() {
  const steps = [{
    icon: <CalendarIcon className="w-6 h-6 text-running-dark" data-id="element-207" />,
    title: 'El Lunes',
    text: 'Arrancás sabiendo exactamente qué va a trabajar cada grupo. No porque lo pensaste el domingo. Sino porque lo planificaste en 20 minutos con un sistema que ya tiene todo resuelto: la fisiología, la periodización, los ejercicios de fuerza y la estrategia nutricional integrados.'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-running-dark" data-id="element-208" />,
    title: 'Cuando un alumno se lesiona',
    text: 'No entrás en pánico. Abrís el protocolo de prevención y readaptación, identificás el patrón biomecánico que generó la lesión, ajustás el plan y seguís adelante. Con datos. Con criterio. Con autoridad profesional.'
  }, {
    icon: <BarChartIcon className="w-6 h-6 text-running-dark" data-id="element-209" />,
    title: 'Al final del mes',
    text: 'Le mostrás a tu alumno exactamente cómo evolucionaron su FC en reposo, su ritmo en zona 2, su economía de carrera y su fuerza funcional. No es una opinión. Son datos. Y los datos retienen alumnos mejor que cualquier clase espectacular sin evidencia.'
  }, {
    icon: <TrendingUpIcon className="w-6 h-6 text-running-dark" data-id="element-210" />,
    title: 'Cuando alguien te pregunta el precio',
    text: 'No dudás. Porque sabés exactamente qué ofrece tu sistema, qué resultados produce y qué valor tiene. La conversación de precio se vuelve la más fácil de tu semana porque el sistema habla por vos.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-running-surface relative overflow-hidden" data-id="element-211">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-running-blue/5 rounded-full blur-[100px] pointer-events-none" data-id="element-212" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-213">
        <FadeIn data-id="element-214">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-16 leading-tight" data-id="element-215">
            Existe una versión de tu trabajo <br className="hidden sm:block" data-id="element-216" />
            <span className="text-running-blue" data-id="element-217">
              que se ve completamente diferente.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-218">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-219">
              <div className="flex flex-col sm:flex-row gap-6 items-start bg-running-dark border border-running-muted p-6 sm:p-8 rounded-2xl relative overflow-hidden group hover:border-running-blue/50 transition-colors" data-id="element-220">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-running-muted group-hover:bg-running-blue transition-colors" data-id="element-221" />
                <div className="bg-running-blue w-12 h-12 rounded-full flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(61,232,255,0.3)]" data-id="element-222">
                  {step.icon}
                </div>
                <div data-id="element-223">
                  <h3 className="text-xl font-display font-bold text-white mb-2" data-id="element-224">
                    {step.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-225">{step.text}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-226">
          <div className="text-center mt-16" data-id="element-227">
            <p className="text-2xl sm:text-3xl font-display font-bold text-white" data-id="element-228">
              Esa versión de tu trabajo no requiere más horas.{' '}
              <br className="hidden sm:block" data-id="element-229" />
              <span className="text-running-blue" data-id="element-230">
                Requiere el sistema correcto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}